/**
 * 应用入口文件
 * 路由配置和全局样式引入
 */
import React from 'react';
import ReactDOM from 'react-dom/client';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import './assets/css/styles.css'; // 引入全局样式和重置样式
import './assets/css/styles.less'; // 引入 Less 文件
import { HelmetProvider } from 'react-helmet-async';

// 导入组件
import Register from '@/components/Auth/Register';
import Login from '@/components/Auth/Login';
import ChangePassword from '@/components/Auth/ChangePassword';
import VerifyEmail from '@/components/Auth/VerifyEmail';
import Profile from '@/components/Profile';
import Discover from '@/components/Discover/Discover';
import Community from '@/components/Community/Community';
import Applications from '@/components/Applications/Applications';
import Layout from '@/components/common/Layout';
import NotFound from '@/components/common/NotFound';
import PrivacyPolicy from '@/components/PrivacyPolicy';
import TermsOfService from '@/components/TermsOfService';
import TextAnalyze from '@/components/Applications/TextAnalyze/TextAnalyze';
import Home from '@/components/Home/Home';
import Dictionary from '@/components/Dictionary/Dictionary';
import PrivateRoute from '@/components/common/PrivateRoute';
import WordList from '@/components/StudyCenter/Vocabulary/WordList';
import ResetPassword from '@/components/Auth/ResetPassword';
import ForgotPassword from '@/components/Auth/ForgotPassword';
import OAuthCallback from '@/components/Auth/OAuthCallback';
import StudyCenter from '@/components/StudyCenter';
import SearchHistory from '@/components/StudyCenter/SearchHistory';
import Collections from '@/components/StudyCenter/Collections';
import HistoryContainer from '@/components/Dictionary/SearchHistory/HistoryContainer';
import DictHistory from '@/components/Dictionary/SearchHistory/DictHistory';
import AiHistory from '@/components/Dictionary/SearchHistory/AiHistory';
// 创建路由器
const router = createBrowserRouter([
  {
    path: '/',
    element: <Layout />,
    children: [
      { index: true, element: <Home /> },
      { path: 'login', element: <Login /> },
      { path: 'register', element: <Register /> },
      { path: 'verify-email', element: <VerifyEmail /> },
      { path: 'forgot-password', element: <ForgotPassword /> },
      { path: 'reset-password/:token', element: <ResetPassword /> },
      { path: 'reset-password', element: <ResetPassword /> },
      { path: 'privacy-policy', element: <PrivacyPolicy /> },
      { path: 'terms-of-service', element: <TermsOfService /> },
      { path: 'oauth/callback', element: <OAuthCallback /> },
      { path: 'applications', element: <Applications /> },
      { path: 'applications/:id', element: <div>应用详情页面</div> },
      { path: 'applications/text-analyze', element: <TextAnalyze /> },
      { path: 'discover', element: <Discover /> },
      { path: 'dictionary', element: <Dictionary /> },
      { path: '/history', element: <HistoryContainer /> },
      { path: '/history/dictionary', element: <DictHistory /> },
      { path: '/history/ai', element: <AiHistory /> },
      {
        path: 'study',
        element: (
          <PrivateRoute>
            <StudyCenter />
          </PrivateRoute>
        ),
      },
      {
        path: 'profile',
        element: (
          <PrivateRoute>
            <Profile />
          </PrivateRoute>
        ),
      },
      {
        path: 'study/summary',
        element: (
          <PrivateRoute>
            <Collections />
          </PrivateRoute>
        ),
      },
      {
        path: 'study/history',
        element: (
          <PrivateRoute>
            <SearchHistory />
          </PrivateRoute>
        ),
      },
      {
        path: 'vocabulary',
        element: (
          <PrivateRoute>
            <Collections />
          </PrivateRoute>
        ),
      },
      {
        path: 'vocabulary/list/:id',
        element: (
          <PrivateRoute>
            <WordList />
          </PrivateRoute>
        ),
      },
      {
        path: 'change-password',
        element: (
          <PrivateRoute>
            <ChangePassword />
          </PrivateRoute>
        ),
      },
      {
        path: 'community',
        element: (
          <PrivateRoute>
            <Community />
          </PrivateRoute>
        ),
      },
      { path: '*', element: <NotFound /> },
    ],
  },
]);

const container = document.getElementById('root');
if (!container) throw new Error('Failed to find the root element');
const root = ReactDOM.createRoot(container);

root.render(
  <React.StrictMode>
    <HelmetProvider>
      <RouterProvider router={router} />
    </HelmetProvider>
  </React.StrictMode>,
);
